export default "__VITE_ASSET__DFjt3JfJ__"